function getPageIndex(index, arr, hasFrontCover, hasBackCover) {
    const pageOffset = 1
    index += pageOffset
    if (hasFrontCover && index === 1) {
        return 'F'
    } else if (isLastPage(index, arr) && hasBackCover) {
        return 'B'
    } else {
        return index.toString()
    }
}

function isLastPage(index, arr) {
    return index === arr.length
}

function convertToFormData(pages, pagesMapping, journalId) {
    let formData = new FormData()
    for (let i = 0; i < pages.length; i++) {
        formData.append('files', pages[i], pages[i]['name'])
    }
    formData.append('pagesMapping', JSON.stringify(pagesMapping))
    formData.append('journalId', journalId)

    return formData
}

export {getPageIndex, convertToFormData}
